export enum CalculationTypesEnum {
  RE2020 = "RE2020",
  BBCA = "BBCA",
  BIOSOURCE = "Biosourcé",
  E_PLUS_C_MOINS = "E+C-",
}
